module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product-link"
  }, [_c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("Subproducts")]), _vm._v(" "), _c('div', [(_vm.productParts.length < 1) ? _c('div', [_vm._v("\n            This product has no subproducts\n            "), _c('br'), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _vm._l((_vm.productParts), function(part) {
    return _c('div', [_c('div', {
      staticClass: "floater"
    }, [_c('div', {
      staticClass: "float-item"
    }, [(_vm.editingPart === part.id) ? _c('div', {
      staticClass: "field"
    }, [_c('p', {
      staticClass: "control"
    }, [_c('input', {
      staticClass: "input item-count-input",
      attrs: {
        "type": "number",
        "min": "1"
      },
      domProps: {
        "value": part.count
      },
      on: {
        "input": function($event) {
          _vm.editPartCount = $event.target.value
        }
      }
    })])]) : _vm._e(), _vm._v(" "), (_vm.editingPart !== part.id) ? _c('strong', [_vm._v(_vm._s(part.count) + " x")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "float-item"
    }, [_c('div', [_c('router-link', {
      attrs: {
        "to": {
          name: 'product',
          params: {
            id: part.product.id
          }
        }
      }
    }, [_vm._v("\n                            " + _vm._s(part.product.name) + "\n                        ")]), _vm._v(" "), (_vm.editingPart !== part.id) ? _c('div', [(part.title) ? _c('strong', [_vm._v(_vm._s(part.title))]) : _vm._e(), _vm._v(" "), (part.description) ? _c('div', [_c('em', [_vm._v(_vm._s(part.description))])]) : _vm._e()]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
      staticClass: "float-item"
    }, [_vm._v("\n                    -\n                     \n                    "), (_vm.editingPart !== part.id) ? _c('span', [_c('a', {
      on: {
        "click": function($event) {
          return _vm.edit(part)
        }
      }
    }, [_vm._v("Edit")]), _vm._v("\n                         \n                        "), _c('a', {
      staticClass: "delete",
      on: {
        "click": function($event) {
          return _vm.remove(part)
        }
      }
    })]) : _c('span', [_c('button', {
      staticClass: "button is-primary",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.update(part)
        }
      }
    }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
      staticClass: "button",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.stopEdit()
        }
      }
    }, [_vm._v("Cancel")])])])]), _vm._v(" "), (_vm.editingPart === part.id) ? _c('div', [_c('br'), _vm._v(" "), _c('div', {
      staticClass: "field"
    }, [_c('label', {
      staticClass: "label"
    }, [_vm._v("Title")]), _vm._v(" "), _c('form-control', {
      attrs: {
        "type": "text",
        "placeholder": "title"
      },
      model: {
        value: (_vm.editPartTitle),
        callback: function($$v) {
          _vm.editPartTitle = $$v
        },
        expression: "editPartTitle"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "field"
    }, [_c('label', {
      staticClass: "label"
    }, [_vm._v("Description")]), _vm._v(" "), _c('form-control', {
      attrs: {
        "type": "textarea",
        "placeholder": "Description"
      },
      model: {
        value: (_vm.editPartDescription),
        callback: function($$v) {
          _vm.editPartDescription = $$v
        },
        expression: "editPartDescription"
      }
    })], 1), _vm._v(" "), _c('div')]) : _vm._e(), _vm._v(" "), _c('br')])
  })], 2), _vm._v(" "), (!_vm.adding) ? _c('div', [_c('a', {
    staticClass: "button is-small",
    on: {
      "click": function($event) {
        _vm.adding = true
      }
    }
  }, [_vm._v("Add subproduct...")])]) : _vm._e(), _vm._v(" "), (_vm.adding) ? _c('div', [_c('div', {
    staticClass: "field"
  }, [_c('p', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("How many?")]), _vm._v(" "), _c('input', {
    staticClass: "input item-count-input",
    attrs: {
      "type": "number",
      "min": "1"
    },
    domProps: {
      "value": _vm.newPartCount
    },
    on: {
      "input": function($event) {
        _vm.newPartCount = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "select inline-select"
  }, [_c('select', {
    attrs: {
      "name": "item-add"
    },
    on: {
      "change": function($event) {
        _vm.newPartProduct = $event.target.value
      }
    }
  }, [_c('option', [_vm._v("Select a product...")]), _vm._v(" "), _vm._l((_vm.availableProducts), function(product) {
    return _c('option', {
      domProps: {
        "value": product.id
      }
    }, [_vm._v(_vm._s(product.name))])
  })], 2)]), _vm._v(" "), _c('button', {
    staticClass: "button is-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.add()
      }
    }
  }, [_vm._v("Add")]), _vm._v(" "), _c('button', {
    staticClass: "button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.adding = false
      }
    }
  }, [_vm._v("Cancel")])])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('p', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Title")]), _vm._v(" "), _c('form-control', {
    attrs: {
      "type": "text",
      "placeholder": "title"
    },
    model: {
      value: (_vm.newPartTitle),
      callback: function($$v) {
        _vm.newPartTitle = $$v
      },
      expression: "newPartTitle"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('p', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Description")]), _vm._v(" "), _c('form-control', {
    attrs: {
      "type": "textarea",
      "placeholder": "Description"
    },
    model: {
      value: (_vm.newPartDescription),
      callback: function($$v) {
        _vm.newPartDescription = $$v
      },
      expression: "newPartDescription"
    }
  })], 1)])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ff15436"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/src/components/products/ProductParts.vue
// module id = 500
// module chunks = 0